import { http } from "../ConnectApi/ConnectApi";

export async function BuyBRLAController(data: { amount: any  }) {
  try {
    const response = await http.post('tftc/buy/brla', data, {
      withCredentials: true
    });

    return response;
  } catch (error: any) {
    console.error('Error during request:', error.response?.data || error.message);
    throw error;
  }
}
